import React, { useState } from "react"
import Modal from './index'
import Button from "../Form/Button"
import BreakForm from './../Form/BreakForm/index'
import FormGroup from "../Form/FormGroup"
import Input from '../Form/Input'
import Select from './../Form/Select'
import FormGroupInline from '../Form/FormGroupInline'
import { FaPencilAlt } from "react-icons/fa"
import { BiPackage } from "react-icons/bi"
import { getOptionByOptionList } from "../../utils/utils"
import { formatCurrency, formatDataSize, formatFloatToPercent } from "../../utils/formatter"

const ModalPlan = ({ isNew = false, value = {}, partnersAccounts = [], modules = [], editable = false, canEdit = true, setEdit, onSubmit, closeModal }) => {
    const [plan, setPlan] = useState(value)

    const optionsStatus = [
        { id: 1, value: "Ativo" },
        { id: 0, value: "Inativo" },
    ]

    const optionsBoolean = [
        { id: 1, value: "Sim" },
        { id: 0, value: "Não" },
    ]

    const handleChangeValue = (name, value) => {
        setPlan(previousValue => { return { ...previousValue, [name]: value } })
    }

    const handleChangeLimits = (name, value) => {
        const newValue = { ...plan?.limits, [name]: value }
        handleChangeValue("limits", newValue)
    }

    const handleChangeAdditionalCost = (name, value) => {
        const newValue = { ...plan?.additional_cost, [name]: value }
        handleChangeValue("additional_cost", newValue)
    }

    const handleCancel = (e) => {
        e.preventDefault()
        if (isNew) {
            closeModal()
        } else {
            setEdit(false)
            setPlan(value)
        }
    }

    return (
        <Modal
            icon={<BiPackage />}
            title={isNew ? "Cadastro de novo plano" : (editable ? `Editando o plano: ${plan.name}` : `Visualizando: ${plan.name}`)}
            description={isNew ? "Adicione um novo plano" : (editable ? "Altere as informações abaixo e clique no botão salvar" : (canEdit ? `Caso queira editar as informações clique no ícone de edição` : "Você tem acesso somente para visualização"))}
            closeModal={closeModal}
        >
            <form onSubmit={(e) => onSubmit(e, isNew, plan)}>
                <FormGroupInline>
                    <FormGroup labelText="Nome">
                        {editable ?
                            <Input type="text" placeholder="Nome do plano" value={plan?.name ?? ""} onChange={(e) => handleChangeValue("name", e.target.value)} />
                            :
                            <span>{plan?.name || "-"}</span>
                        }
                    </FormGroup>
                    {!editable && canEdit &&
                        <Button variant="secondary" className="action" onClick={() => setEdit(true)}>
                            <FaPencilAlt />
                        </Button>
                    }
                </FormGroupInline>
                <FormGroup labelText="Descrição">
                    {editable ?
                        <Input type="text" placeholder="Descrição do plano" value={plan?.description ?? ""} onChange={(e) => handleChangeValue("description", e.target.value)} />
                        :
                        <span>{plan?.description || "-"}</span>
                    }
                </FormGroup>
                <FormGroupInline>
                    <FormGroup labelText="Valor">
                        {editable ?
                            <Input type="currency" placeholder="Valor do plano" value={plan?.value ?? ""} onChange={(e) => handleChangeValue("value", e.target.value)} />
                            :
                            <span>{formatCurrency(plan?.value) || "-"}</span>
                        }
                    </FormGroup>
                    <FormGroup labelText="Porcentagem de Comissão">
                        {editable ?
                            <Input type="number" placeholder="Porcentagem de Comissão do plano" value={plan?.percentage_transfer ?? ""} onChange={(e) => handleChangeValue("percentage_transfer", e.target.value)} />
                            :
                            <span>{formatFloatToPercent(plan?.percentage_transfer) || "-"}</span>
                        }
                    </FormGroup>
                </FormGroupInline>
                <FormGroupInline>
                    <FormGroup labelText="Teste Grátis">
                        {editable ?
                            <Select multiple={false} name="Período de Teste" placeholder="Buscar..." options={optionsBoolean} onChange={(value) => handleChangeValue("trial_active", value)} selected={+plan?.trial_active ?? ""} />
                            :
                            <span>{getOptionByOptionList(+plan?.trial_active, optionsBoolean)}</span>
                        }
                    </FormGroup>
                    <FormGroup labelText="Período de Teste">
                        {editable ?
                            <Input type="number" placeholder="Período de Teste" value={plan?.trial_days || "-"} onChange={(e) => handleChangeValue("trial_days", e.target.value)} />
                            :
                            <span>{plan?.trial_days || "-"}</span>
                        }
                    </FormGroup>
                </FormGroupInline>
                <BreakForm title="Limites" showAction={false} />
                <FormGroupInline>
                    <FormGroup labelText="Usuários">
                        {editable ?
                            <Input type="number" placeholder="Limite de Usuários" value={plan?.limits?.users ?? ""} onChange={(e) => handleChangeLimits("users", e.target.value)} />
                            :
                            <span>{plan?.limits?.users || "-"}</span>
                        }
                    </FormGroup>
                    <FormGroup labelText="Leads">
                        {editable ?
                            <Input type="number" placeholder="Limite de Leads" value={plan?.limits?.leads ?? ""} onChange={(e) => handleChangeLimits("leads", e.target.value)} />
                            :
                            <span>{plan?.limits?.leads || "-"}</span>
                        }
                    </FormGroup>
                </FormGroupInline>
                <FormGroupInline>
                    <FormGroup labelText="Equipes">
                        {editable ?
                            <Input type="number" placeholder="Limite de Equipes" value={plan?.limits?.teams || "0"} onChange={(e) => handleChangeLimits("teams", e.target.value)} />
                            :
                            <span>{plan?.limits?.teams || "-"}</span>
                        }
                    </FormGroup>
                    <FormGroup labelText="Armazenamento MB (Por Usuário)">
                        {editable ?
                            <Input type="number" placeholder="Limite de Armazenamento em MB" value={plan?.limits?.storage_per_user ?? ""} onChange={(e) => handleChangeLimits("storage_per_user", e.target.value)} />
                            :
                            <span>{formatDataSize(plan?.limits?.storage_per_user || 0) || "-"}</span>
                        }
                    </FormGroup>
                </FormGroupInline>
                <FormGroup labelText="Créditos IA mensais">
                    {editable ?
                        <Input type="number" placeholder="Créditos IA incluídos por mês" value={plan?.limits?.chat_credits_monthly ?? "0"} onChange={(e) => handleChangeLimits("chat_credits_monthly", e.target.value)} />
                        :
                        <span>{plan?.limits?.chat_credits_monthly || "0"} créditos/mês</span>
                    }
                </FormGroup>
                <BreakForm title="Custo Adicional" showAction={false} />
                <FormGroupInline>
                    <FormGroup labelText="Usuários">
                        {editable ?
                            <Input type="currency" placeholder="Custo por usuário adicional" value={plan?.additional_cost?.users ?? ""} onChange={(e) => handleChangeAdditionalCost("users", e.target.value)} />
                            :
                            <span>{formatCurrency(plan?.additional_cost?.users) || "-"}</span>
                        }
                    </FormGroup>
                    <FormGroup labelText="Leads (pacote de 1000)">
                        {editable ?
                            <Input type="currency" placeholder="Custo por pacote de 1000 leads" value={plan?.additional_cost?.leads ?? ""} onChange={(e) => handleChangeAdditionalCost("leads", e.target.value)} />
                            :
                            <span>{formatCurrency(plan?.additional_cost?.leads) || "-"} / 1000 leads</span>
                        }
                    </FormGroup>
                </FormGroupInline>
                <FormGroup labelText="Pagamento por Usuário">
                    {editable ?
                        <Select multiple={false} name="Pagamento por Usuário" placeholder="Buscar..." options={optionsBoolean} onChange={(value) => handleChangeValue("payment_by_user", value)} selected={+plan?.payment_by_user ?? ""} />
                        :
                        <span>{getOptionByOptionList(+plan?.payment_by_user, optionsBoolean)}</span>
                    }
                </FormGroup>
                <FormGroup labelText="Disponível no autoatendimento">
                    {editable ?
                        <Select multiple={false} name="Disponível no autoatendimento" placeholder="Buscar..." options={optionsBoolean} onChange={(value) => handleChangeValue("show_self_service", value)} selected={+(plan?.show_self_service ?? 1)} />
                        :
                        <span>{getOptionByOptionList(+(plan?.show_self_service ?? 1), optionsBoolean)}</span>
                    }
                </FormGroup>
                <FormGroup labelText="Pagamento para Parceiro">
                    {editable ?
                        <Select multiple={false} name="Pagamento para Parceiro" placeholder="Buscar..." options={optionsBoolean} onChange={(value) => handleChangeValue("payment_by_partner", value)} selected={+plan?.payment_by_partner ?? ""} />
                        :
                        <span>{getOptionByOptionList(+plan?.payment_by_partner, optionsBoolean)}</span>
                    }
                </FormGroup>
                <FormGroup labelText="Status">
                    {editable ?
                        <Select multiple={false} name="Status" placeholder="Buscar..." options={optionsStatus} onChange={(value) => handleChangeValue("is_active", value)} selected={+plan?.is_active ?? ""} />
                        :
                        <span>{getOptionByOptionList(+plan?.is_active, optionsStatus)}</span>
                    }
                </FormGroup>
                <FormGroup labelText="Módulos">
                    {editable ?
                        <Select multiple={true} name="Módulos" placeholder="Buscar..." options={modules} onChange={(value) => handleChangeValue("modules", value)} selected={plan?.modules ?? []} />
                        :
                        <span>{getOptionByOptionList(plan?.modules, modules) || "-"}</span>
                    }
                </FormGroup>
                <FormGroup labelText="Contas">
                    {editable ?
                        <Select multiple={true} name="Contas" placeholder="Buscar..." options={partnersAccounts} onChange={(value) => handleChangeValue("accounts", value)} selected={plan?.accounts ?? []} />
                        :
                        <span>{getOptionByOptionList(plan?.accounts, partnersAccounts) || "-"}</span>
                    }
                </FormGroup>
                {editable &&
                    <FormGroupInline>
                        <Button variant='primary' type="submit">Salvar</Button>
                        <Button variant='secondary' onClick={handleCancel}>Cancelar</Button>
                    </FormGroupInline>
                }
            </form>
        </Modal>
    )
}

export default ModalPlan
